import { render } from "./recordTestPaper.vue?vue&type=template&id=20b599a6&scoped=true"
import script from "./recordTestPaper.vue?vue&type=script&lang=js"
export * from "./recordTestPaper.vue?vue&type=script&lang=js"

import "./recordTestPaper.vue?vue&type=style&index=0&id=20b599a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b599a6"]])

export default __exports__